__turbopack_context__.v({
  "followButton": "FollowButton-module-scss-module__0QYDHq__followButton",
  "following": "FollowButton-module-scss-module__0QYDHq__following",
  "organizer": "FollowButton-module-scss-module__0QYDHq__organizer",
  "textContainer": "FollowButton-module-scss-module__0QYDHq__textContainer",
});
